import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions/analytics';
import AccountMultiple from 'mdi-material-ui/AccountMultiple';

class ActiveUsers extends React.Component {
    componentDidMount() {
        this.props.getActiveUsers();

        this.activeUserInterval = setInterval(
            function() {
                this.props.getActiveUsers();
            }.bind(this),
            30 * 1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.activeUserInterval);
    }

    render() {
        return (
            <div className="analytics">
                <AccountMultiple style={{ fontSize: 30 }} />
                <span>{this.props.activeUsers}</span>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeUsers: state.analytics.activeUsers,
    };
}

export default connect(
    mapStateToProps,
    actions
)(ActiveUsers);



// WEBPACK FOOTER //
// ./src/components/ActiveUsers.js